export default __webpack_public_path__ + "static/media/success-icon.5a266a42.svg";